/* eslint-disable react/no-deprecated */
import $ from 'jquery';
import { Component } from 'react';
import { localToUtc, utcToLocal } from 'trends/company/utils';
import { weekdayStringsSundayStart } from 'common/utils/date';

class SubscriptionSettingsClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subscription_type: 'TrendsTeamMailer',
      id: '',
      interval: 'disabled',
      day_of_week: undefined,
      send_at: undefined,
      loading: false,
      error: false,
      success: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fetchSubscription = this.fetchSubscription.bind(this);
  }

  componentDidMount() {
    this.fetchSubscription();
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      error: false,
      success: false,
    });
  }

  fetchSubscription() {
    this.setState({ loading: true });
    $.ajax({
      url: `/api/v1/subscription`,
      type: 'GET',
      cache: false,
      data: { subscription_type: 'TrendsTeamMailer' },
      dataType: 'json',
      success: data => {
        if (data && data.send_at) {
          this.setState({
            ...data,
            ...utcToLocal(data.day_of_week, data.send_at, true),
          });
        }
      },
      complete: () => {
        this.setState({ loading: false });
      },
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ loading: true });
    const subscriptionData = {
      ...this.state,
      ...localToUtc(this.state.day_of_week, this.state.send_at, true),
    };
    const method = this.state.id ? 'PUT' : 'POST';
    $.ajax({
      url: `/api/v1/subscription/${this.state.id}`,
      type: method,
      cache: false,
      data: subscriptionData,
      dataType: 'json',
      success: data => {
        this.setState({
          error: false,
          loading: false,
          success: true,
          ...data,
          ...utcToLocal(data.day_of_week, data.send_at, true),
        });
      },
      error: () => {
        this.setState({ error: true, loading: false, success: false });
      },
    });
    return false;
  }

  render() {
    return (
      <div className="edit-subscription-container">
        <div
          className="email-settings-toggle btn btn-secondary"
          data-target=".js-edit-subscription-settings"
          data-toggle="modal"
        >
          Subscribe
        </div>
        <div className="js-edit-subscription-settings edit-subscription modal fade">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-close close" data-dismiss="modal">
                ×
              </div>
              <div className="modal-title">Subscription settings</div>
              <div>
                Email digests let you stay on top of changes week over week.
                They provide a snapshot of the data you see here and are always
                for the last 7 days compared to the 7 days before that. You can
                schedule these to be delivered to your inbox daily or weekly at
                the time of your choosing. Times are shown in your current
                timezone.
              </div>
              <form
                className="js-subscription-form"
                onSubmit={this.handleSubmit}
                onChange={this.handleChange}
              >
                <div
                  className="loading"
                  style={{ display: this.state.loading ? 'flex' : 'none' }}
                >
                  <i className={`fa fa-spinner`} />
                </div>
                <div className="field form-group">
                  <div className="radio-button-area">
                    <label style={{ marginRight: '15px' }}>Interval</label>
                    <input
                      className="radio-custom"
                      name="interval"
                      value="disabled"
                      id="disabled"
                      type="radio"
                      checked={this.state.interval === 'disabled'}
                      onChange={this.handleChange}
                    />
                    <label className="radio-custom-label" htmlFor="disabled">
                      Disabled
                    </label>
                    <input
                      className="radio-custom"
                      name="interval"
                      value="daily"
                      id="daily"
                      type="radio"
                      checked={this.state.interval === 'daily'}
                      onChange={this.handleChange}
                    />
                    <label className="radio-custom-label" htmlFor="daily">
                      Daily
                    </label>
                    <input
                      className="radio-custom"
                      name="interval"
                      value="weekly"
                      id="weekly"
                      type="radio"
                      checked={this.state.interval === 'weekly'}
                      onChange={this.handleChange}
                    />
                    <label className="radio-custom-label" htmlFor="weekly">
                      Weekly
                    </label>
                  </div>
                </div>
                <div className="field form-group">
                  <label>Send at</label>
                  <select
                    className="select-dropdown"
                    name="send_at"
                    value={this.state.send_at?.toString()}
                    onChange={this.handleChange}
                  >
                    <option value="">Choose a time</option>
                    {Array(24)
                      .fill(0)
                      .map((_, index) => {
                        const hour = index % 12 === 0 ? 12 : index % 12;
                        const meridian = index < 12 ? 'A.M.' : 'P.M.';
                        return (
                          <option key={index} value={index}>
                            {hour}:00 {meridian}
                          </option>
                        );
                      })}
                  </select>
                </div>
                {this.state.interval === 'weekly' && (
                  <div className="field form-group">
                    <label>Day of week</label>
                    <select
                      className="select-dropdown"
                      name="day_of_week"
                      value={this.state.day_of_week?.toString()}
                      onChange={this.handleChange}
                    >
                      <option value="">Choose a day</option>
                      {weekdayStringsSundayStart
                        .map((dayOfWeek, dayIndex) => {
                          return (
                            <option key={dayIndex} value={dayIndex}>
                              {dayOfWeek}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                )}
                <input type="hidden" name="type" value="team" />
                <div
                  className="message bg-success"
                  style={{ display: this.state.success ? 'inherit' : 'none' }}
                >
                  Settings succesfully saved!
                </div>
                <div
                  className="message bg-danger"
                  style={{ display: this.state.error ? 'inherit' : 'none' }}
                >
                  Settings could not be saved.
                </div>
                <button className="btn btn-primary" type="submit">
                  {this.state.success ? 'Saved' : 'Save'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SubscriptionSettingsClass;
/* eslint-enable react/no-deprecated */
